<template>
    <v-card flat height="calc(100vh - 154px)" class="overflow-y pt-8">
      <v-container class="pt-0" fluid>
        <v-row>

          <v-card :width="$vuetify.breakpoint.mobile ? $vuetify.breakpoint.width-30 : 500" class="ml-4 mt-2 mb-4">
            <v-toolbar color="primary" dark>General</v-toolbar>
            <v-expansion-panels multiple>

              <v-expansion-panel>
                <v-expansion-panel-header>Date/time</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-general-dates/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Currency</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-general-currency/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel v-if="$store.getters.company.connectedToAccounting">
                <v-expansion-panel-header>Accounts</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-general-accounts/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Excise handling</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-general-excise/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <component :is="province"/>
            </v-expansion-panels>
          </v-card>

          <v-card :width="$vuetify.breakpoint.mobile ? $vuetify.breakpoint.width-30 : 500" class="ml-4 mt-2 mb-4">
            <v-toolbar color="primary" dark>Production</v-toolbar>
            <v-expansion-panels multiple>

              <v-expansion-panel>
                <v-expansion-panel-header>Mashing</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-mashing-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Wine fermenting</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-wine-fermenting-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Distilling</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-distilling-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Blending</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-blending-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Bottling</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-bottling-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Assembly</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <production-assembly-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </v-card>

          <v-card :width="$vuetify.breakpoint.mobile ? $vuetify.breakpoint.width-30 : 500" class="ml-4 mt-2 mb-4">
            <v-toolbar color="primary" dark>Inventory</v-toolbar>
            <v-expansion-panels multiple>

              <v-expansion-panel>
                <v-expansion-panel-header>Spirits</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-inventory-spirits/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Products</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <settings-preferences-inventory-products/>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </v-card>

          <v-card :width="$vuetify.breakpoint.mobile ? $vuetify.breakpoint.width-30 : 500" class="ml-4 mt-2 mb-4">
            <v-toolbar color="primary" dark>Purchasing and sales</v-toolbar>
            <v-expansion-panels multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>Purchase orders</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <purchasing-purchase-orders-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Sales</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <sales-preferences/>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

        </v-row>
      </v-container>
    </v-card>
</template>

<script>
import SettingsPreferencesGeneralDates from '@/views/settings/preferences/general/SettingsPreferencesGeneralDates'
import SettingsPreferencesGeneralCurrency from '@/views/settings/preferences/general/SettingsPreferencesGeneralCurrency'
import SettingsPreferencesGeneralExcise from '@/views/settings/preferences/general/SettingsPreferencesGeneralExcise'
import SettingsPreferencesGeneralAccounts from '@/views/settings/preferences/general/SettingsPreferencesGeneralAccounts'

import ProductionMashingPreferences from '@/views/production/mashing/ProductionMashingPreferences'
import ProductionWineFermentingPreferences from '@/views/production/wineFermenting/ProductionWineFermentingPreferences'
import ProductionDistillingPreferences from '@/views/production/distilling/ProductionDistillingPreferences'
import ProductionBlendingPreferences from '@/views/production/blending/ProductionBlendingPreferences'
import ProductionBottlingPreferences from '@/views/production/bottling/ProductionBottlingPreferences'
import ProductionAssemblyPreferences from '@/views/production/assembly/ProductionAssemblyPreferences'

import SettingsPreferencesInventorySpirits from '@/views/settings/preferences/inventory/SettingsPreferencesInventorySpirits'
import SettingsPreferencesInventoryProducts from '@/views/settings/preferences/inventory/SettingsPreferencesInventoryProducts'

import PurchasingPurchaseOrdersPreferences from '@/views/purchasing/purchaseOrders/PurchasingPurchaseOrdersPreferences'
import SalesPreferences from '@/views/sales/SalesPreferences'

export default {
  name: 'SettingsPreferences',
  components: {SettingsPreferencesGeneralDates,SettingsPreferencesGeneralCurrency,SettingsPreferencesGeneralExcise,SettingsPreferencesGeneralAccounts,
               ProductionMashingPreferences,ProductionWineFermentingPreferences,ProductionDistillingPreferences,ProductionBlendingPreferences,ProductionBottlingPreferences,ProductionAssemblyPreferences,
               SettingsPreferencesInventorySpirits,SettingsPreferencesInventoryProducts,
               PurchasingPurchaseOrdersPreferences,SalesPreferences},
  data() {
    return {
      province: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  mounted() {
    this.province = () => import(`@/views/provinces/${this.company.province}/configuration/ConfigurationSettings`);
  },
  methods: {
    load() {
    }
  }
}
</script>